import { render, staticRenderFns } from "./custom-report-detail.vue?vue&type=template&id=886a293c&scoped=true&"
import script from "./custom-report-detail.vue?vue&type=script&lang=js&"
export * from "./custom-report-detail.vue?vue&type=script&lang=js&"
import style0 from "./custom-report-detail.vue?vue&type=style&index=0&id=886a293c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886a293c",
  null
  
)

export default component.exports